<template>
  <layouts-auth>
    <layouts-auth-width>
      <div class="padding-auth-contents">
        <base-alert class="mb-4" />
        <div class="card-outlined p-4">
          <h1 class="text-subtitle-underline">{{ t('account.change_mode.title') }}</h1>
          <form @submit.prevent="onSubmit">
            <div class="mb-4 pl-2">
              <div>
                <input
                  type="radio"
                  id="default"
                  value="default"
                  v-model="display_mode"
                  class="mb-2 mr-2 cursor-pointer"
                >
                <label for="default" class="cursor-pointer">{{ t('display_mode.default') }}</label>
              </div>
              <div>
                <input
                  type="radio"
                  id="well_labo"
                  value="well_labo"
                  v-model="display_mode"
                  class="mr-2 cursor-pointer"
                >
                <label for="well_labo" class="cursor-pointer">{{ t('display_mode.well_labo') }}</label>
              </div>
            </div>
            <div class="flex items-center pt-2">
              <base-form-submit :disabled="btnDisabled" :text="t('word.change')" />
            </div>
          </form>
        </div>
      </div>
    </layouts-auth-width>
  </layouts-auth>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from '@/store/index'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { axios } from '@/plugins/axios'
import { ALERT_COLORS } from '@/store/base'

import LayoutsAuth from '@/layouts/Auth.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'
import BaseFormSubmit from '@/components/BaseFormSubmit.vue'
import BaseAlert from '@/components/BaseAlert.vue'

type AccountChangeModeValues = {
  display_mode: string
}

export default defineComponent({
  components: {
    LayoutsAuth,
    LayoutsAuthWidth,
    BaseFormSubmit,
    BaseAlert
  },
  setup() {
    const { t } = useI18n()
    const store = useStore()
    const btnDisabled = ref(false)
    const initialValues: AccountChangeModeValues = {
      display_mode: store.state.user.user?.display_mode ?? 'default',
    }

    const schema = yup.object({
      display_mode: yup.string(),
    })

    const { handleSubmit, errors } = useForm<AccountChangeModeValues>({
      validationSchema: schema,
      initialValues
    })

    const { value: display_mode } = useField<string>('display_mode')

    const onSubmit = handleSubmit(values => {
      btnDisabled.value = true
      axios
        .post('/account/change-mode', values)
        .then(response => {
          store.commit('user/setUser', response.data.payload)
          store.commit('base/setAlertMessages', { messages: [t('account.change_mode.success')], color: ALERT_COLORS.info })
        })
        .finally(() => btnDisabled.value = false)
    })

    return {
      t,
      errors,
      display_mode,
      onSubmit,
      btnDisabled,
      store
    }
  }
})
</script>
